export function severityBadgeClass(severity: string | undefined): string {
  switch ((severity ?? '').toLowerCase()) {
    case 'high':
      return 'tw:border-transparent tw:bg-destructive/15 tw:text-destructive';
    case 'medium':
      return 'tw:border-transparent tw:bg-amber-400/25 tw:text-amber-800 tw:dark:text-amber-200';
    case 'low':
    default:
      return 'tw:border-transparent tw:bg-blue-500/20 tw:text-blue-800 tw:dark:text-blue-200';
  }
}
